import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { FilterViewLayoutModule } from '@go-modules/components/filter-view-layout/filter-view-layout.module';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { NgxActivityTableViewComponent } from './activity-table-view/activity-table-view.component';
import { NgxActivityGridViewComponent } from './activity-grid-view/activity-grid-view.component';
import { NgxFolderViewComponent } from './folder-view.component';
import { NgxActivityCardModule } from '@go-modules/components/folder-view/activity-card/activity-card.module';
import { GridVirtualScrollViewportModule } from '@go-modules/components/grid-virtual-scroll-viewport/grid-virtual-scroll-viewport.module';
import { DataSourceZeroStateModule } from '@go-modules/components/data-source-zero-state/data-source-zero-state.module';
import { NgxActivityListStatusModule } from '@go-modules/components/folder-view/activity-list-status/activity-list-status.module';
import { ActivityListDataSource } from '@go-modules/services/activity-list-datasource/activity-list.datasource';
import { ActivityMenuModule } from '@go-modules/components/menus/activity-menu/activity-menu.module';
import { MatMenuModule } from '@angular/material/menu';
import { DotIndicatorModule } from '@go-modules/components/dot-indicator/dot-indicator.module';
import { GoSelectModule } from '@go-modules/directives/go-select/go-select.module';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';
import { CommentIndicatorModule } from '@go-modules/components/comment-indicator/comment-indicator.module';
import { OutsideClickModule } from '@go-modules/directives/outside-click';
import { MenuModule } from '@go-modules/components/menus/menu/menu.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CourseContextMenuModule } from '@go-modules/components/folder-view/course-context-menu/course-context-menu.module';
import { ActivityReorderModule } from '@go-modules/components/sidepanels/activity-reorder/activity-reorder.module';
import { FolderZeroStateComponent } from './folder-zero-state/folder-zero-state.component';
import { CopyActivitiesDialogModule } from '@go-modules/components/dialogs/copy-activities-dialog/copy-activities-dialog.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxActivityDueDateComponent } from './activity-due-date/activity-due-date.component';
import { ToggleGridListViewComponent } from '../toggle-grid-list-view/toggle-grid-list-view.component';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		TranslateModule,
		GoMaterialModule,
		FilterViewLayoutModule,
		GridVirtualScrollViewportModule,
		NgxActivityCardModule,
		DataSourceZeroStateModule,
		NgxActivityListStatusModule,
		ActivityMenuModule,
		MatMenuModule,
		DotIndicatorModule,
		GoSelectModule,
		NgxZeroStateModule,
		CommentIndicatorModule,
		OutsideClickModule,
		MatTooltipModule,
		MenuModule,
		ReactiveFormsModule,
		CourseContextMenuModule,
		ActivityReorderModule,
		CopyActivitiesDialogModule,
		NgxActivityDueDateComponent,
		ToggleGridListViewComponent
	],
	declarations: [
		NgxFolderViewComponent,
		NgxActivityTableViewComponent,
		NgxActivityGridViewComponent,
		FolderZeroStateComponent
	],
	exports: [
		NgxFolderViewComponent,
		NgxActivityTableViewComponent,
		NgxActivityGridViewComponent,
		FolderZeroStateComponent
	],
	providers: [
		TranslatePipe,
		ActivityListDataSource
	]
})
export class NgxFolderViewModule {}
